import { motion, useReducedMotion } from 'motion/react';
import { CdnImage } from '../CdnImage';
import { CDN } from '../../lib/cdn';

const HIGHLIGHTS = [
  {
    number: '01',
    label: 'Pre-production',
    title: 'AI Previz for Filmmakers',
    body: 'Block out every scene before you shoot or render a single frame — Induce\'s previsualization tools turn a script into a shot-accurate previz pass in minutes.',
    image: CDN.filmmakers.direction,
    alt: 'A film scene being planned shot by shot',
  },
  {
    number: '02',
    label: 'Pitch reels',
    title: 'From Script to Pitch Reel',
    body: 'Generate a fundable pitch reel straight from your script — no casting, no set, no crew.',
    image: CDN.filmmakers.assembly,
    alt: 'A sequence of film shots assembled into a cut',
  },
] as const;

export function FilmmakerHighlights() {
  const reducedMotion = useReducedMotion();

  return (
    <section className="fm-highlights band-light" aria-label="Filmmaking workflows">
      <div className="container fm-highlights-grid">
        {HIGHLIGHTS.map((item, index) => (
          <motion.article
            key={item.number}
            className="fm-highlight-card"
            initial={reducedMotion ? false : { opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={reducedMotion ? undefined : { y: -3 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.7, delay: index * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="fm-highlight-visual">
              <CdnImage src={item.image} alt={item.alt} loading="lazy" />
              <span className="fm-highlight-number">{item.number}</span>
            </div>
            <div className="fm-highlight-copy">
              <span className="label-mono">{item.label}</span>
              <h2>{item.title}</h2>
              <p>{item.body}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
